<template>
  <div>
    <app-date/>
    <hr>
    <app-confreres/>
    <hr>
    <app-ajout-filtre/>
  </div>
</template>

<script>
import filtreDate from './date';
import confreres from './confreres';
import AjoutFiltre from './ajoutFiltre';

export default {
  name: 'filtres',
  components: {
    appDate: filtreDate,
    appAjoutFiltre: AjoutFiltre,
    appConfreres: confreres,
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteReseauxLc/filtres/filtresPatrimoine.vue